<script setup lang="ts">
import { Btn, Card, MapEmbed } from '@bagelink/vue'

const menuItems: Array<{
	title: string
	desc: string
	note?: string
	img: string
}> = [
	{
		title: 'Chicken Sweet & Sour',
		desc: 'Crispy. Tangy. Addictive. You’ll be licking your fingers and wondering why you didn’t order the large.',
		img: '/menu/item-1.png',
		note: 'Available in 2 sizes'
	},
	{
		title: 'Zezy’s Signature Zoppers',
		desc: 'The OG wing experience. These babies made us famous.',
		img: '/menu/item-2.png',
		note: 'Available in Medium & Large'
	},
	{
		title: 'Crispy Wings',
		desc: 'Golden, crunchy, and full of sholom bayis. Yes, your spouse will love you more after sharing these.',
		img: '/menu/item-3.png',
		note: 'Choose 6 or 12 pieces'
	},
	{
		title: 'Zoppers Schnitzelonim',
		desc: 'Small but mighty. The perfect snack or kids’ favorite.',
		img: '/menu/item-4.png',
		note: 'Comes in 2 sizes'
	},
	{
		title: 'Sides & Shabbat Dishes',
		desc: 'Fresh rice, golden fries, and more — Ask about our Shabbat takeout menu!',
		img: '/menu/item-5.png',
		note: 'Available in Medium & Large'
	}
]
</script>

<template>
	<div class="testMe1">
		<!-- top -->
		<div class="flex p-1 space-between w-100p relative bg-gray-light">
			<a href="https://www.zezy.co.il/">
				<img src="@/assets/logo-yellow.svg" alt="Zezy's Zoppers" class="relative z-1">
			</a>
			<a href="#kosher">
				<img height="50px" src="@/assets/kosher-black.png" alt="kosher" class="relative z-1">
			</a>
			<!-- <img src="@/assets/big-z.svg" alt="" class="absolute z-0 -top-10 end start w-1200px opacity-7"> -->
		</div>

		<!-- hero -->
		<div class="relative z-1 txt-center px-1 bg-gray-light">
			<h1 class="fixed opacity-0 txt9">
				Zezy's Zoppers
			</h1>
			<h2 class="hugeTitle line-height-0 uppercase black absolute inset">
				Yummy
			</h2>
			<img src="@/assets/main-img.png" alt="Zoppers" class="relative z-1 w-980px -mb-4 m_-mb-2 w-100p">
			<h3 class="regular balance">
				The Flavor You’ve Been Praying For
			</h3>
			<div class="flex gap-1 justify-content-center pb-1">
				<Btn round class="bold" color="black" value="Order Online" href="https://order.atmos.rest/zoppers_il/order/order-type" />
				<Btn round class="bold" color="black" outline value="WhatsApp Us" icon="whatsapp" href="https://wa.me/0535455475" />
			</div>
			<p class="bold">
				Or call 053-545-5475
			</p>
		</div>
		<img src="../assets/torn-yellow.png" alt="" class="w-100p bg-gray-light">

		<!-- about -->
		<div class="grid grid-wrap-2 gap-1 justify-content-center px-1 relative z-1 w-1200px m_gap-0">
			<img
				src="@/assets/about.jpg" alt="About Zezy's Zoppers"
				class="w-100p w-500px  relative z-1 mt-2-5 shadow radius-1"
			>
			<Card class="-ms-10 ps-10 m_mx-0 m_px-1-5 m_pt-3 m_-mt-1 shadow">
				<h3 class="txt28 m-0 pb-05 m_txt24">
					Kosher Crunch Central
				</h3>
				<p class="pb-1">
					Welcome to Zezy’s Zoppers, the home of crispy, juicy, soul-satisfying schnitzels and wings with a kosher twist — straight from the one and only Zezy Fuld (aka Rabbi Eliezer Fuld when he’s not in the kitchen)!
				</p>
				<p>
					Since 2020, Zezy’s been bringing flavor, fun, and a whole lot of crunch to the heart of Beit Shemesh. Whether you’re feeding the family, prepping for Shabbat, or just craving something delicious — Zezy’s got you.
				</p>
			</Card>
		</div>

		<!-- menu -->
		<div class="relative z-1 w-1000px mt-7 m_mt-2 px-1 pt-2">
			<img src="@/assets/logo-back.svg" alt="zezy's zoppers" class="absolute inset w-100p opacity-7">
			<p class="txt30 bold line-height-14 txt-center relative z-1 m_txt20">
				Order Now — and join the hundreds of happy customers who’ve made Zezy’s Zoppers a local legend.
			</p>
			<div class="display-flex gap-2 flex-wrap py-2 justify-content-center">
				<Card
					v-for="(item, idx) in menuItems"
					:key="idx"
					class="p-0 shadow overflow-hidden w-300px display-flex column m-0"
				>
					<img :src="item.img" :alt="item.title" class="h-250px w100p cover">
					<div class="p-1">
						<p class="bold">
							{{ item.title }}
						</p>
						<p>
							{{ item.desc }}
						</p>
						<p v-if="item.note" class="txt14 light">
							{{ item.note }}
						</p>
					</div>
				</Card>
			</div>
		</div>
		<img src="@/assets/purim.jpg" alt="Purim Celebration" class="w1000px block shadow radius-1">
		<!-- quote -->
		<div class="txt-center w700px pt-7 m_pt-2">
			<img src="@/assets/hat.png" alt="hat" class="w50px">
			<p class="txt30 balance py-1 m_txt-20">
				“I just wanted to make food that makes people happy — and maybe a little full.”
			</p>
			<img src="@/assets/mustache.svg" alt="mustache" class="w-100px">
		</div>
		<!-- location -->
		<div class="relative overflow-hidden pt-7 m_mt-2 m_txt16">
			<img src="@/assets/top-view.png" alt="" class="w-400px aspect-ratio-1 top -end-10 absolute z-999 pointer-events-none user-select-none m_w-200px  m_-end-3">
			<MapEmbed
				:height="300"
				style="background: var(--bgl-gray)"
				:center="[31.7089439, 34.9967694]"
				:zoom="15"
				:markers="[{ lat: 31.7089439, lng: 34.9967694 }]"
			/>
			<div class="m_px-1">
				<Card class="-mt-2 relative z-999 round shadow w700px py-1 txt-center mx-auto">
					<p>
						Order for pickup or delivery from our Beit Shemesh location:
						<br>
						📍 21 Nachal Luz, Beit Shemesh
					</p>
				</Card>
				<div class="txt-center pt-2">
					<div class="flex gap-1 justify-content-center pb-1">
						<Btn round class="bold" color="black" value="Order Online" href="https://order.atmos.rest/zoppers_il/order/order-type" />
						<Btn round class="bold" color="black" outline value="WhatsApp Us" icon="whatsapp" href="https://wa.me/0535455475" />
					</div>
					<p class="bold">
						Or call 053-545-5475
					</p>
				</div>
			</div>
		</div>
		<!-- footer -->
		<div id="kosher" class="footerBg flex gap-1 color-white justify-content-center h250px align-items-end pb-2 px-2">
			<img src="@/assets/kosher-white.png" alt="kosher" class="h-50px">
			<p class=" line-height-14 m_txt16">
				<span class="block bold">Kosher Supervision</span>We proudly operate under Badatz Kehillot Hashgacha
			</p>
		</div>
	</div>
</template>

<style>
.hugeTitle{
	font-size: clamp(2rem, 20vw, 350px);
}
.footerBg{
	background-image: url('@/assets/torn.png');
	background-size: cover;
	background-position: center top;
}
</style>
